const UserDropdown = ({ image }: { image?: string }) => {
  return (
    <div className="block w-9 h-9 rounded-full">
      {image ? (
        <img src={image} alt="prof" className="w-9 h-9 rounded-full" />
      ) : (
        <img
          src="/images/icons/not-registered.svg"
          className="w-9 h9  bg-deehiy text-white rounded-full border-deehiy "
        />
      )}
    </div>
  );
};

export default UserDropdown;
